const yandexWebmaster = {
    onPageLoaded: () => {
        if (window?.YandexRotorSettings) {
            window.YandexRotorSettings.IsLoaded = true;
        }
    },
}

export default yandexWebmaster;const yandexWebmaster = {
    onPageLoaded: () => {
        if (window?.YandexRotorSettings) {
            window.YandexRotorSettings.IsLoaded = true;
        }
    },
}

export default yandexWebmaster;